export interface Tenant {
  id: string;
  label: string;
  path: string;
}

export const TENANTS: Tenant[] = [
  { id: 'backroom', label: 'The Back Room', path: '/r/backroom' },
  { id: 'atlanticgrowshop', label: 'The Grow Shop', path: '/r/atlanticgrowshop' },
];

export const getTenantById = (id: string): Tenant | undefined =>
  TENANTS.find((t) => t.id === id);
